import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const CaliforniaMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='california'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='CA_ZSE'
				points='814.85 681.26 839.37 705.61 844.77 725.4 851.8 735.88 858.08 754.38 871.69 767 873.43 776.23 860.8 789.85 852.29 804.37 851.81 816.83 850.49 827.76 839.94 849.42 834.01 865.71 646.33 698.49 814.85 681.26'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'CA_ZSE' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('CA_ZSE')}
			/>
			<polyline
				id='CA_ZCE'
				points='646.33 698.49 814.85 681.26 471.78 340.63 333.94 327.85 452.09 492.5 552.57 634.84 646.33 698.49'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'CA_ZCE' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('CA_ZCE')}
			/>
			<polygon
				id='CA_ZNE'
				points='471.78 340.63 483.84 72.47 344.81 62.07 333.94 327.85 471.78 340.63'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'CA_ZNE' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('CA_ZNE')}
			/>
			<polygon
				id='CA_ZSW'
				points='646.33 698.49 434.77 748.4 489.56 770.72 537.04 787.1 557.31 796.23 565.83 808.68 569.57 822.6 589.32 829.01 610.84 841.83 629.28 859.17 640.45 876.75 646.29 904.88 647.52 920.39 658.86 932.88 828.08 917.98 847.32 912.68 855.8 900.97 848.1 892.86 837.64 888.07 834.01 865.71 646.33 698.49'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'CA_ZSW' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('CA_ZSW')}
			/>
			<polygon
				id='CA_ZCW'
				points='215.29 312.89 222.62 342.99 234.54 361.56 252.94 381.71 261.06 392 267.44 420.03 291.44 434.07 293.71 416.22 305.96 406.61 328.77 402.33 344.96 407.73 357.99 414.27 362.1 424.18 347.61 421.84 333.49 415.5 310.95 415.23 302.1 421.96 306.65 440.21 313.13 450.8 322.03 468.25 305.87 460.04 295.89 442.8 289.55 456.92 296.92 484.2 317.09 519.77 329.75 539.32 329.82 560.66 326.74 574.17 330.24 589.82 349.96 617.03 380.72 655.11 405.06 685.95 406.39 702.01 403.58 719.96 418.14 734.66 434.77 748.4 646.33 698.49 552.57 634.84 333.94 327.85 215.29 312.89'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'CA_ZCW' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('CA_ZCW')}
			/>
			<polygon
				id='CA_ZNW'
				points='215.29 312.89 216.3 273.35 214.02 246.23 194.63 208.83 189.74 191.76 198.11 161.52 205.23 127.58 207.48 76.64 211.87 52.13 344.81 62.07 333.94 327.85 215.29 312.89'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'CA_ZNW' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('CA_ZNW')}
			/>
			<rect
				x='204.51'
				y='128.44'
				width='119.69'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M203.9,167.96l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M237.76,171.04l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<path
				d='M281.64,171.04l-1.98-40.44h5l.86,24.24c.15,5.23.05,7.99,0,10.53h.14c.94-2.64,1.93-5.26,4.16-10.25l11.2-24.53h5.33l.83,23.28c.19,5.24.18,8.75.09,11.42h.13c1.19-3.48,2.4-6.72,3.95-10.41l10.9-24.28h5.22l-18.76,40.44h-5.27l-1.03-23c-.22-4.7-.17-7,.09-11.63h-.15c-1.35,3.88-2.42,6.97-4.09,10.64l-11.28,24h-5.34Z'
				className='shape'
			/>
			<rect
				x='349.04'
				y='557.26'
				width='119.69'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M348.43,596.79l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M408.98,598.55c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.62,3.08-14.88,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M420.76,599.86l-1.98-40.44h5l.86,24.24c.15,5.23.05,7.99,0,10.53h.14c.94-2.64,1.93-5.26,4.16-10.25l11.2-24.53h5.33l.83,23.28c.19,5.24.18,8.75.09,11.42h.13c1.19-3.48,2.4-6.72,3.95-10.41l10.9-24.28h5.22l-18.76,40.44h-5.27l-1.03-23c-.22-4.7-.17-7,.09-11.63h-.15c-1.35,3.88-2.42,6.97-4.09,10.64l-11.28,24h-5.34Z'
				className='shape'
			/>
			<rect
				x='677.05'
				y='854.5'
				width='119.69'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M676.43,894.03l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M710.92,890.85c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<path
				d='M744.21,897.1l-1.98-40.44h5l.86,24.24c.15,5.23.05,7.99,0,10.53h.14c.94-2.64,1.93-5.26,4.16-10.25l11.2-24.53h5.33l.83,23.28c.19,5.24.18,8.75.09,11.42h.13c1.19-3.48,2.4-6.72,3.95-10.41l10.9-24.28h5.22l-18.76,40.44h-5.27l-1.03-23c-.22-4.7-.17-7,.09-11.63h-.15c-1.35,3.88-2.42,6.97-4.09,10.64l-11.28,24h-5.34Z'
				className='shape'
			/>
			<rect
				x='364.15'
				y='243.82'
				width='99.47'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M363.53,283.34l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M397.39,286.42l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<path
				d='M458.59,267.41h-14.69l-2.79,14.75h16.55l-.82,4.26h-21.52l7.69-40.44h20.61l-.83,4.25h-15.6l-2.47,12.95h14.71l-.83,4.23Z'
				className='shape'
			/>
			<rect
				x='568.13'
				y='536.47'
				width='99.47'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M567.51,575.99l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M628.07,577.76c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.02c-1.5-.91-4.35-1.67-7.95-1.67-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M656.69,560.06h-14.69l-2.79,14.75h16.55l-.82,4.26h-21.52l7.69-40.44h20.61l-.83,4.25h-15.6l-2.47,12.95h14.71l-.83,4.23Z'
				className='shape'
			/>
			<rect x='746.3' y='720' width='99.47' height='43.33' fill='none' className='shape' />
			<path
				d='M745.69,759.52l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M780.17,756.34c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<path
				d='M830.78,743.59h-14.69l-2.79,14.75h16.55l-.82,4.26h-21.52l7.69-40.44h20.61l-.83,4.25h-15.6l-2.47,12.95h14.71l-.83,4.23Z'
				className='shape'
			/>
			<polygon
				points='222.54 62.07 222.64 66.39 227.19 66.39 222.71 69.06 222.82 73.39 219.94 70.72 215.46 73.39 218.16 69.06 215.29 66.39 219.83 66.39 222.54 62.07'
				className='shape'
			/>
			<rect x='221.14' y='75.33' width='155.33' height='20' fill='none' className='shape' />
			<path
				d='M233.07,91.84c-.91.41-2.38.77-4.2.77-4.07,0-6.57-2.59-6.57-6.72,0-3.05,1.23-5.95,3.45-7.8,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M237.54,92.37l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M255.82,91.7c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM253.62,82.04c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M260.84,90.35c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M280.11,91.91c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.02-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.1,2.89,3.1,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M292.85,91.7c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM290.65,82.04c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M297.78,92.37l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M318.21,77.64l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M340.99,91.84c-.91.41-2.38.77-4.2.77-4.07,0-6.57-2.59-6.57-6.72,0-3.05,1.23-5.95,3.45-7.8,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M345.46,92.37l2.22-11.61h1.99l-2.22,11.61h-1.99ZM348.05,77.52c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M358.58,77.64l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M366.12,80.76l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.32.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<polygon
				points='341.19 176.86 341.29 181.18 345.84 181.18 341.36 183.86 341.47 188.18 338.59 185.51 334.11 188.18 336.81 183.86 333.94 181.18 338.48 181.18 341.19 176.86'
				className='shape'
			/>
			<rect x='345.79' y='183.12' width='94.18' height='20' fill='none' className='shape' />
			<path
				d='M349.57,184.22c.99-.22,2.33-.35,3.53-.35,1.62,0,3,.38,3.86,1.17.75.65,1.19,1.58,1.19,2.68,0,2.35-1.8,4.1-3.84,4.68v.06c1.13.38,1.66,1.59,1.78,3.25.18,2.26.29,3.8.5,4.45h-2.06c-.09-.34-.26-2.04-.37-3.9-.13-2.23-.94-3.14-2.55-3.14h-1.77l-1.34,7.05h-1.97l3.03-15.94ZM350.16,191.56h1.78c2.52,0,4.15-1.65,4.15-3.59,0-1.73-1.3-2.51-3.13-2.51-.79,0-1.3.07-1.68.17l-1.13,5.92Z'
				className='shape'
			/>
			<path
				d='M369.77,199.49c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM367.57,189.83c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M387.06,183.12l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM383.72,190.37c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<path
				d='M402.08,183.12l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM398.74,190.37c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<path
				d='M404.76,200.16l2.22-11.61h1.99l-2.22,11.61h-1.99ZM407.35,185.31c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M412.68,200.16l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M428.02,202.79c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM436.95,190.28c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<polygon
				points='347.87 359.59 347.97 363.92 352.52 363.92 348.04 366.59 348.15 370.91 345.27 368.24 340.79 370.91 343.49 366.59 340.62 363.92 345.16 363.92 347.87 359.59'
				className='shape'
			/>
			<rect x='352.47' y='365.85' width='140.77' height='20' fill='none' className='shape' />
			<path
				d='M353.46,380.39c.88.59,2.09,1.03,3.44,1.03,1.82,0,3.5-1.09,3.5-3.04,0-1.2-.68-2.1-2.37-3.02-2.07-1.12-3.22-2.41-3.22-4.15,0-2.9,2.49-4.75,5.46-4.75,1.58,0,2.76.46,3.31.84l-.71,1.63c-.51-.31-1.52-.77-2.81-.76-2,0-3.2,1.32-3.21,2.64,0,1.31.82,2.06,2.51,3,1.99,1.07,3.09,2.34,3.09,4.33,0,2.8-2.2,5-5.84,5-1.62,0-3.21-.53-3.89-1.12l.72-1.63Z'
				className='shape'
			/>
			<path
				d='M374.67,382.89c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM375.96,372.77c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M389.91,382.43c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.02-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.1,2.89,3.1,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M394.52,382.89l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M411.92,382.89c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM413.21,372.77c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M419.22,382.89l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.76l-.31,2.18h.06c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.27-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.3,6.85h-1.94l1.25-6.69c.08-.45.17-1.04.17-1.52,0-1.23-.47-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<path
				d='M449.41,382.22c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM447.2,372.57c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M454.33,382.89l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M474.77,368.16l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M490.55,375.84c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM481.62,378.31c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<polygon
				points='299.23 446.57 299.34 450.89 303.89 450.89 299.41 453.56 299.52 457.89 296.64 455.21 292.16 457.89 294.86 453.56 291.99 450.89 296.53 450.89 299.23 446.57'
				className='shape'
			/>
			<rect x='301.08' y='457.68' width='162.75' height='20' fill='none' className='shape' />
			<path
				d='M302.08,472.21c.88.59,2.09,1.03,3.44,1.03,1.82,0,3.5-1.09,3.5-3.04,0-1.2-.68-2.1-2.37-3.03-2.07-1.12-3.22-2.41-3.22-4.15,0-2.9,2.49-4.75,5.46-4.75,1.58,0,2.76.46,3.31.84l-.71,1.63c-.51-.31-1.52-.77-2.81-.76-2,0-3.2,1.32-3.21,2.64,0,1.31.82,2.06,2.51,3,1.99,1.07,3.09,2.34,3.09,4.33,0,2.8-2.2,5-5.84,5-1.62,0-3.21-.53-3.89-1.12l.72-1.63Z'
				className='shape'
			/>
			<path
				d='M323.29,474.72c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM324.58,464.59c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M330.59,474.72l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.48,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M355.76,458.54h8.21l-.33,1.7h-6.21l-1.04,5.46h5.72l-.33,1.69h-5.72l-1.38,7.33h-1.99l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M365.7,474.72l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M383.09,474.72c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM384.38,464.59c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M390.4,474.72l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.48,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M413.62,474.26c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.03-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.11,2.89,3.11,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M418.23,474.72l2.22-11.61h1.99l-2.22,11.61h-1.99ZM420.82,459.87c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M426.25,472.7c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.86.56,1.37,1.6,1.96,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M445.52,474.26c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.03-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.11,2.89,3.11,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M461.03,467.67c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.15-4.53-4.77,0-3.84,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM452.1,470.14c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<polygon
				points='473.83 746.01 473.94 750.33 478.49 750.33 474.01 753.01 474.12 757.33 471.24 754.66 466.76 757.33 469.46 753.01 466.59 750.33 471.13 750.33 473.83 746.01'
				className='shape'
			/>
			<rect x='478.44' y='752.27' width='172.64' height='20' fill='none' className='shape' />
			<path
				d='M479.43,766.81c.88.59,2.09,1.03,3.44,1.03,1.82,0,3.5-1.09,3.5-3.04,0-1.2-.68-2.1-2.37-3.03-2.07-1.12-3.22-2.41-3.22-4.15,0-2.9,2.49-4.75,5.46-4.75,1.58,0,2.76.46,3.31.84l-.71,1.63c-.51-.3-1.52-.77-2.81-.76-2,0-3.2,1.32-3.21,2.64,0,1.31.82,2.06,2.51,3,1.99,1.07,3.09,2.34,3.09,4.33,0,2.8-2.2,5-5.84,5-1.62,0-3.21-.53-3.89-1.12l.72-1.63Z'
				className='shape'
			/>
			<path
				d='M500.64,769.31c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM501.93,759.19c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M507.94,769.31l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M528.38,754.58l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.13-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M540.79,769.31c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM542.08,759.19c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M557.93,753.36c.99-.2,2.15-.33,3.47-.33,1.67,0,2.87.34,3.73,1.11.75.61,1.16,1.47,1.16,2.52,0,2.04-1.65,3.56-3.48,4.04v.06c1.46.43,2.67,1.64,2.65,3.59,0,1.66-.88,2.96-1.94,3.75-1.28.96-3.07,1.33-5.24,1.33-1.39,0-2.6-.08-3.35-.23l2.99-15.83ZM557.16,767.7c.51.08,1.09.1,1.64.1,2.36.01,4.57-.97,4.57-3.56,0-1.9-1.6-2.73-3.42-2.73h-1.62l-1.17,6.19ZM558.65,760h1.48c2.32,0,4.11-1.2,4.11-3.17,0-1.56-1.18-2.22-2.94-2.22-.73,0-1.34.05-1.65.15l-1,5.24Z'
				className='shape'
			/>
			<path
				d='M577.46,769.31c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM578.75,759.19c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M584.76,769.31l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M599.91,752.27l-1.53,7.53h.05c1.03-1.55,2.52-2.36,4.08-2.36,2.54,0,3.52,2.1,3.52,4.16,0,3.57-2.58,7.98-7.23,7.98-2.04,0-3.58-.85-3.58-2.99,0-.57.1-1.25.2-1.8l2.5-12.51h1.99ZM597.4,764.82c-.08.39-.15.86-.14,1.47.01,1.1.64,1.71,1.88,1.71,3.01,0,4.82-3.57,4.82-6.15,0-1.44-.63-2.77-2.22-2.77-1.71,0-3.5,1.78-4.08,4.5l-.26,1.23Z'
				className='shape'
			/>
			<path
				d='M617.52,769.31c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM618.81,759.19c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M624.82,769.31l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M642.21,769.31c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM643.5,759.19c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<polygon
				points='586.49 810.55 586.6 814.87 591.15 814.87 586.67 817.55 586.77 821.87 583.9 819.2 579.42 821.87 582.12 817.55 579.24 814.87 583.79 814.87 586.49 810.55'
				className='shape'
			/>
			<rect x='591.09' y='816.81' width='140.77' height='20' fill='none' className='shape' />
			<path
				d='M594.92,817.67h1.99l-2.76,14.45h6.53l-.33,1.73h-8.5l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M612.43,833.85c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM613.72,823.72c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M619.83,831.83c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.96,1.29.73,2.17,1.74,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M641.25,828.73l-2.57,5.12h-2.1l8.36-16.18h2.35l2.24,16.18h-2.04l-.65-5.12h-5.58ZM646.69,827.15l-.63-4.67c-.09-.84-.21-2.03-.29-2.98h-.06c-.43.96-.83,1.97-1.32,2.95l-2.41,4.7h4.71Z'
				className='shape'
			/>
			<path
				d='M654.13,833.85l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M669.47,836.48c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM678.39,823.96c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M692.74,833.18c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM690.54,823.52c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path d='M697.67,833.85l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M713.95,833.18c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM711.75,823.52c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M718.97,831.83c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.96,1.29.73,2.17,1.74,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<polygon
				points='457.91 517.52 458.01 521.84 462.56 521.84 458.08 524.51 458.19 528.84 455.31 526.16 450.83 528.84 453.53 524.51 450.66 521.84 455.2 521.84 457.91 517.52'
				className='shape'
			/>
			<rect x='462.51' y='523.77' width='86.31' height='20' fill='none' className='shape' />
			<path
				d='M466.33,524.64h8.21l-.33,1.7h-6.21l-1.04,5.46h5.72l-.33,1.69h-5.72l-1.38,7.33h-1.99l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M476.27,540.81l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M494.55,540.15c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM492.35,530.49c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M499.57,538.8c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M510.85,540.81l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M537.23,533.77c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM528.3,536.23c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<polygon
				points='662.8 905.22 662.91 909.54 667.45 909.54 662.97 912.21 663.08 916.54 660.21 913.86 655.73 916.54 658.43 912.21 655.55 909.54 660.1 909.54 662.8 905.22'
				className='shape'
			/>
			<rect x='537.23' y='887.84' width='122.63' height='20' fill='none' className='shape' />
			<path
				d='M538.23,902.37c.88.59,2.09,1.03,3.44,1.03,1.82,0,3.5-1.09,3.5-3.04,0-1.2-.68-2.1-2.37-3.02-2.07-1.12-3.22-2.41-3.22-4.15,0-2.9,2.49-4.75,5.46-4.75,1.58,0,2.76.46,3.31.84l-.71,1.63c-.51-.31-1.52-.77-2.81-.76-2,0-3.2,1.32-3.21,2.64,0,1.31.82,2.06,2.51,3,1.99,1.07,3.09,2.34,3.09,4.33,0,2.8-2.2,5-5.84,5-1.62,0-3.21-.53-3.89-1.12l.72-1.63Z'
				className='shape'
			/>
			<path
				d='M559.43,904.88c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM560.72,894.75c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M566.73,904.88l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M591.87,888.91c1.24-.22,2.6-.32,4.02-.32,2.7,0,4.76.77,5.95,2.15.87.9,1.51,2.35,1.52,4.39,0,2.93-1.16,5.83-3.25,7.6-1.87,1.57-4.23,2.25-7.33,2.25-1.41,0-2.87-.08-3.92-.2l3.01-15.87ZM591.15,903.22c.73.1,1.49.11,2.09.11,2.57,0,4.44-.76,5.79-2.15,1.46-1.49,2.21-3.69,2.21-5.97,0-2.86-1.4-5-5.43-5-.72,0-1.63.04-2.21.17l-2.44,12.84Z'
				className='shape'
			/>
			<path
				d='M606.86,904.88l2.22-11.61h1.99l-2.22,11.61h-1.99ZM609.45,890.03c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M623.15,904.21c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM620.95,894.55c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M628.18,907.51c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1.01-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM637.1,894.99c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M654.22,897.83c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM645.29,900.29c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<polygon
				points='531.68 441.42 531.79 445.74 536.33 445.74 531.85 448.42 531.96 452.74 529.09 450.07 524.61 452.74 527.31 448.42 524.43 445.74 528.98 445.74 531.68 441.42'
				className='shape'
			/>
			<rect
				x='536.28'
				y='447.68'
				width='118.75'
				height='47.52'
				fill='none'
				className='shape'
			/>
			<path
				d='M550.58,464.72l1.16-8.74c.21-1.54.57-3.91.88-5.47h-.08c-.75,1.63-1.65,3.56-2.53,5.21l-4.81,8.9h-1.52l-1.2-8.71c-.25-1.86-.41-3.74-.52-5.4h-.05c-.34,1.5-.85,3.94-1.23,5.48l-2.2,8.73h-1.87l4.19-16.18h2.54l1.28,9.28c.16,1.38.35,2.85.39,4.06h.07c.49-1.2,1.19-2.65,1.88-4l5.01-9.33h2.6l-2.05,16.18h-1.94Z'
				className='shape'
			/>
			<path
				d='M565.8,464.72c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM567.1,454.59c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M573.11,464.72l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.76l-.31,2.18h.06c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.27-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.3,6.85h-1.94l1.25-6.69c.08-.45.17-1.03.17-1.52,0-1.23-.47-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<path
				d='M594.92,464.72l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.76l-.31,2.18h.06c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.27-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.3,6.85h-1.94l1.25-6.69c.08-.45.17-1.03.17-1.52,0-1.23-.47-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<path
				d='M627.88,457.67c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.15-4.53-4.77,0-3.84,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM618.95,460.14c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M636.89,449.99l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M641.63,464.72l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M540.11,470.54h1.99l-2.76,14.45h6.53l-.33,1.73h-8.5l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M557.62,486.72c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM558.91,476.59c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M564.88,486.72l3.24-17.04h1.98l-2.04,10.68h.05c.35-.41.78-.85,1.09-1.17l4.09-4.08h2.46l-5.06,4.77,3.47,6.84h-2.19l-2.79-5.73-1.47,1.31-.83,4.42h-1.98Z'
				className='shape'
			/>
			<path
				d='M586.28,486.05c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM584.08,476.39c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M591.3,484.7c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.86.56,1.37,1.6,1.96,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
		</svg>
	);
};

CaliforniaMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default CaliforniaMap;
